// extracted by mini-css-extract-plugin
module.exports = {"wrap":"DeviceIcon_wrap__325pN","inactive":"DeviceIcon_inactive__2P9hX","icon":"DeviceIcon_icon__155Fq","statusIcon":"DeviceIcon_statusIcon__3dcNh"};